import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'processingCheckbox',
    'permitCountTag',
    'pendingCountTag',
    'canPermitCountTag',
    'canPermitCountParentTag'
  ];
  static values = {
    capacityCount: Number,
    applicationsCount: Number,
  };

  connect() {
    this.displayCount();
  }

  checkAll() {
    for (const el of this.processingCheckboxTargets) {
      if(el.disabled) {
        continue;
      }

      el.checked       = true;
      el.indeterminate = false;
    }

    this.displayCount();
  }

  uncheckAll() {
    for (const el of this.processingCheckboxTargets) {
      if(el.disabled) {
        continue;
      }

      el.checked       = false;
      el.indeterminate = false;
    }

    this.displayCount();
  }

  displayCount() {
    const { permitCount, pendingCount, canPermitCount } = this.calcCount();

    this.permitCountTagTarget.textContent = permitCount;
    this.pendingCountTagTarget.textContent = pendingCount;
    this.canPermitCountTagTarget.textContent = canPermitCount;
    this.canPermitCountParentTagTarget.classList.toggle('count-post-it-label--warn', canPermitCount < 0);
  }

  calcCount() {
    const permitCount = this.processingCheckboxTargets.filter(el => el.checked).length;
    const pendingCount = this.applicationsCountValue - permitCount;
    const canPermitCount = this.capacityCountValue - permitCount;
    
    return {
      permitCount,
      pendingCount,
      canPermitCount
    };
  }

  randomCheck() {
    const shuffle = checkboxes => checkboxes.sort(() => Math.random() - 0.5);

    let canPermitCount = this.capacityCountValue;
    let checkboxes = shuffle(this.processingCheckboxTargets);


    // 下記の申請の種類の順番で定員が0になるまでチェックを入れる
    const checkboxesTypes = {
      staffApplications: [], // 職員申請
      autoEnrollments:   [], // 自動履修
      recentlyRejecteds: [], // 前回不許可
      notTransfer:       [], // 振替対象以外
      others:            [], // その他
    };

    checkboxes.forEach(c => {
      if(c.dataset.isStaffApplication === 'true') {
        checkboxesTypes.staffApplications.push(c);
      } else if (c.dataset.isAutoEnrollment === 'true') {
        checkboxesTypes.autoEnrollments.push(c);
      } else if (c.dataset.isRecentlyRejectedStudent === 'true') {
        checkboxesTypes.recentlyRejecteds.push(c);
      } else if (c.dataset.isTransferApplication !== 'true') {
        checkboxesTypes.notTransfer.push(c);
      } else {
        checkboxesTypes.others.push(c);
      }
    });

    const checkedTargets = Object.keys(checkboxesTypes).reduce((acc, type) => {
      if(canPermitCount === 0) {
        return acc;
      }

      const targets = checkboxesTypes[type].slice(0, canPermitCount);
      canPermitCount -= targets.length;

      return [
       ...acc,
       ...targets
      ];
    }, []);

    for (const el of this.processingCheckboxTargets) {
      if(el.disabled) {
        continue;
      }

      const checked = checkedTargets.includes(el);

      el.checked = checked;
      el.indeterminate = false;
    }

    this.displayCount();
  }
}
